module.exports = __webpack_public_path__ + "static/img/feature1.548cf1a2.jpg";